<template>
	<section class="title-warp">
		<div class="title-box" v-for="(item, idx) in Titles" :key="idx">
			<h3 class="title one-line">{{item.Content}}</h3>
		</div>
	</section>
</template>

<script>
export default {
	name: 'StartStop',
	props: ['Titles']
}
</script>

<style lang="scss" scoped>
.title-warp {
	padding: 12px 0;
	position: relative;
}
.title-warp:before {
	content: "";
	position: absolute;
	display: block;
	width: 1px;
	top: 25px;
	bottom: 22px;
	background: #e4e4e4;
	left: 2px;
	z-index: 1;
}
.title-box {
	display: -webkit-box;
	-webkit-box-align: center;
	-webkit-box-pack: justify;
	margin-bottom: 12px;
	position: relative;
	padding-left: 15px;
	.title {
		display: block;
		font-size: 16px;
		color: #333;
		font-weight: bold;
		margin-right: 8px;
		-webkit-box-flex: 1;
	}
}
.title-box:last-child {
	margin-bottom: 0;
}
.title-box:before {
	content: "";
	display: block;
	width: 5px;
	height: 5px;
	border-radius: 50%;
	position: absolute;
	top: 50%;
	-webkit-transform: translateY(-50%);
	transform: translateY(-50%);
	left: 0;
	z-index: 2;
	background: #e4e4e4;
}
.title-box:last-child:before {
	background: #18b86e;
}
</style>



// WEBPACK FOOTER //
// src/template/title/StartStop.vue